var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDedicatedHosting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "165px",
    height: "76.465px",
    viewBox: "0 0 165 76.465",
    enableBackground: "new 0 0 165 76.465",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M119.145,18.128h36.792c4.987,0,9.064-4.077,9.064-9.064 c0-4.986-4.077-9.063-9.064-9.063H51.404c-4.982,0-9.063,4.077-9.063,9.063c0,4.987,4.076,9.064,9.063,9.064h11.925 c3.97,0,7.212,3.242,7.212,7.211c0,3.965-3.242,7.211-7.212,7.211H23.75c-4.987,0-9.064,4.077-9.064,9.064 c0,4.986,4.077,9.063,9.064,9.063h108.105c4.986,0,9.063-4.077,9.063-9.063c0-4.987-4.077-9.064-9.063-9.064h-12.711 c-3.978,0-7.22-3.246-7.22-7.211C111.925,21.37,115.167,18.128,119.145,18.128L119.145,18.128z M26.528,18.128H12.59H9.063 c-4.986,0-9.063-4.081-9.063-9.064c0-4.982,4.081-9.063,9.063-9.063h17.466c4.987,0,9.063,4.077,9.063,9.063 C35.592,14.051,31.516,18.128,26.528,18.128z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFCD2B",
    d: "M75.47,76.464c18.808,0,34.131-15.324,34.131-34.13 c0-18.797-15.323-34.129-34.131-34.129c-18.798,0-34.13,15.333-34.13,34.129C41.34,61.14,56.672,76.464,75.47,76.464z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#114779",
    d: "M98.801,47.805c0.529,0,0.959,0.43,0.959,0.959c0,0.525-0.43,0.955-0.959,0.955s-0.96-0.43-0.96-0.955 C97.841,48.234,98.271,47.805,98.801,47.805z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114779",
    d: "M102.621,47.805c0.529,0,0.959,0.43,0.959,0.959c0,0.525-0.43,0.955-0.959,0.955s-0.951-0.43-0.951-0.955 C101.67,48.234,102.092,47.805,102.621,47.805z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114779",
    d: "M106.45,47.805c0.529,0,0.951,0.43,0.951,0.959c0,0.525-0.422,0.955-0.951,0.955s-0.959-0.43-0.959-0.955 C105.491,48.234,105.921,47.805,106.45,47.805z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114779",
    d: "M87.33,34.42h9.561v-5.735H87.33V34.42z M89.24,30.595h5.731v1.915H89.24V30.595z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114779",
    d: "M117.92,28.685H98.801v5.735h19.119V28.685z M116.01,32.51h-15.299v-1.915h15.299V32.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114779",
    d: "M98.801,36.334h3.82v1.91h-3.82V36.334z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114779",
    d: "M105.491,36.334h12.429v1.91h-12.429V36.334z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114779",
    d: "M98.801,40.159h19.119v1.91H98.801V40.159z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114779",
    d: "M87.33,36.334h9.561v1.91H87.33V36.334z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114779",
    d: "M87.33,40.159h9.561v1.91H87.33V40.159z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114779",
    d: "M108.36,15.3h11.471c2.108,0,3.828-1.716,3.828-3.825c0-2.108-1.72-3.825-3.828-3.825h-17.21V4.384 l-4.383-4.383H68.763L64.38,4.384V46.85c0,1.584,1.285,2.869,2.869,2.869h16.35c0.446,2.18,2.373,3.825,4.683,3.825h4.78v3.825 H89.24v1.91h26.77v-1.91h-3.829v-3.825h4.789c2.63,0,4.779-2.146,4.779-4.78V29.64c0-2.638-2.149-4.78-4.779-4.78h-2.87v-1.914 c0-2.109-1.72-3.821-3.829-3.821h-1.91c-1.05,0-1.91-0.86-1.91-1.915S107.311,15.3,108.36,15.3z M88.281,24.86 c-1.555,0-2.926,0.757-3.798,1.911H66.29v-9.56h34.421v7.649H88.281z M83.499,38.245H66.29v-9.56h17.309 c-0.066,0.306-0.1,0.628-0.1,0.955V38.245z M100.711,5.736V15.3H66.29V5.736H100.711z M69.557,1.911h27.888l1.919,1.915H67.646 L69.557,1.911z M66.29,46.85v-6.69h17.209v7.646h-16.25C66.72,47.805,66.29,47.379,66.29,46.85z M110.271,57.369H94.972v-3.825 h15.299V57.369z M116.97,51.63H88.281c-1.579,0-2.867-1.286-2.867-2.866v-2.869h34.417v2.869 C119.831,50.344,118.549,51.63,116.97,51.63z M119.831,29.64v14.339H85.414V29.64c0-1.58,1.288-2.87,2.867-2.87h28.688 C118.549,26.771,119.831,28.061,119.831,29.64z M108.36,21.035h1.91c1.059,0,1.91,0.856,1.91,1.911v1.914h-9.56V9.561h17.21 c1.059,0,1.918,0.86,1.918,1.914c0,1.055-0.859,1.911-1.918,1.911H108.36c-2.108,0-3.82,1.716-3.82,3.825 S106.252,21.035,108.36,21.035z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114779",
    d: "M70.119,13.386h9.56c1.051,0,1.91-0.856,1.91-1.911V9.561c0-1.055-0.859-1.911-1.91-1.911h-9.56 c-1.059,0-1.915,0.856-1.915,1.911v1.914C68.204,12.53,69.061,13.386,70.119,13.386z M73.939,11.475V9.561h1.91v1.914H73.939z  M79.679,11.475h-1.914V9.561h1.914V11.475z M70.119,9.561h1.91v1.914h-1.91V9.561z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114779",
    d: "M95.931,13.386c1.58,0,2.87-1.286,2.87-2.866c0-1.583-1.29-2.87-2.87-2.87 c-1.579,0-2.869,1.286-2.869,2.87C93.062,12.1,94.352,13.386,95.931,13.386z M95.931,9.561c0.529,0,0.96,0.43,0.96,0.959 c0,0.525-0.431,0.955-0.96,0.955s-0.959-0.43-0.959-0.955C94.972,9.991,95.401,9.561,95.931,9.561z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114779",
    d: "M79.679,30.595h-9.56c-1.059,0-1.915,0.86-1.915,1.915v1.91c0,1.055,0.856,1.915,1.915,1.915h9.56 c1.051,0,1.91-0.86,1.91-1.915v-1.91C81.589,31.455,80.729,30.595,79.679,30.595z M75.85,32.51v1.91h-1.91v-1.91H75.85z  M70.119,32.51h1.91v1.91h-1.91V32.51z M77.765,34.42v-1.91h1.914v1.91H77.765z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114779",
    d: "M71.07,19.125c-1.58,0-2.866,1.286-2.866,2.865c0,1.584,1.286,2.87,2.866,2.87 c1.583,0,2.869-1.286,2.869-2.87C73.939,20.411,72.653,19.125,71.07,19.125z M71.07,22.946c-0.525,0-0.951-0.426-0.951-0.956 c0-0.525,0.426-0.955,0.951-0.955c0.528,0,0.959,0.43,0.959,0.955C72.029,22.52,71.599,22.946,71.07,22.946z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114779",
    d: "M68.204,42.069h1.915v3.825h-1.915V42.069z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114779",
    d: "M72.029,42.069h1.91v3.825h-1.91V42.069z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114779",
    d: "M75.85,42.069h1.915v3.825H75.85V42.069z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDedicatedHosting);
export default __webpack_public_path__ + "static/media/dedicated-hosting.24a6b9a7dcea2ec115680694ec812447.svg";
export { ForwardRef as ReactComponent };